<template>
  <div class="live-record">
    <scroll :pullUpLoad="true" :probeType="3" class="scroll-wrapper" ref="scrollRef">
      <div class="content-wrapper">
        <div
          class="record-item"
          v-for="(item, index) in programList"
          :key="item.id"
          @click="handleClickRecordItem(item, index)"
        >
          <div class="active-record-item" v-if="playIndex === index"></div>
          <img :src="item.pictureUrl" />
          <div class="record-item-right">
            <div class="record-item-right-title" :class="{ 'active-item': playIndex === index }">
              {{ item.intro }}
            </div>
            <div class="record-item-right-nickname" :class="{ 'active-item': playIndex === index }">
              {{ item.nickname }}
            </div>
            <div class="record-item-right-time">
              {{ item.startTime + " - " + item.endTime }}
            </div>
            <div class="record-item-right-bottom">{{ item.startDate }}</div>
          </div>
          <div class="record-item-icon">
            <i class="v-icon-play-circle-o" v-if="playIndex !== index" />
            <playing-icon v-else />
          </div>
        </div>
        <div class="end-tips">已经到底了~</div>
      </div>
    </scroll>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import Scroll from "@/components/Scroll/Scroll";
import PlayingIcon from "@/components/Base/PlayingIcon";
import { getProgramReplayInfos } from "@/http/api";

export default defineComponent({
  name: "LivingRecord",
  components: {
    Scroll,
    PlayingIcon
  },
  props: {
    radioStationCode: {
      type: String
    },
    programCode: {
      type: String
    }
  },
  emits: ["playRecord"],
  setup(props, { emit }) {
    const playIndex = ref(-1);
    const scrollRef = ref(null);
    const programList = ref([]);

    const getRecordList = async () => {
      const result = await getProgramReplayInfos({
        programCode: props.programCode,
        playDays: 8,
        radioStationCode: props.radioStationCode
      });
      if (result && result.code === "1") {
        programList.value = result.data;
      }
      console.log(result);
    };

    const handleClickRecordItem = (item, index) => {
      playIndex.value = index;
      emit("playRecord", item);
    };

    onMounted(async () => {
      await getRecordList();
      scrollRef.value.scroll.refresh();
    });

    return {
      playIndex,
      scrollRef,
      programList,
      handleClickRecordItem
    };
  }
});
</script>

<style lang="scss" scoped>
.live-record {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: hidden;

  .scroll-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 0 17px;
    overflow: hidden;

    .content-wrapper {
      width: 100%;
      min-height: calc(100% + 2px);
    }

    .record-item {
      position: relative;
      margin-top: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0 8px;
      box-sizing: border-box;
      height: 110px;
      border: 1px solid #e1e6e9;
      border-radius: 11px;

      .active-record-item {
        position: absolute;
        right: 8px;
        top: 8px;
        width: 6px;
        height: 6px;
        background: rgba(217, 65, 24, 0.6);
        border-radius: 50%;
      }

      & > img {
        width: 80px;
        height: 80px;
        border-radius: 8px;
      }

      .record-item-right {
        flex: 1;
        height: 75px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 12px;
        padding-left: 15px;
        box-sizing: border-box;
        color: #999;

        .record-item-right-title {
          font-size: 14px;
          color: #111;
        }

        .record-item-right-nickname {
          color: #406599;
        }
      }
      .record-item-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        color: rgba(70, 81, 102, 0.5);

        .v-icon-play-circle-o {
          font-size: 30px;
        }
      }
    }

    .end-tips {
      padding: 15px 0;
      text-align: center;
      font-size: 14px;
      color: #999;
      letter-spacing: 1px;
      text-indent: 1px;
    }
  }
}
</style>
